import { render } from "./DynamicInputNumber.vue?vue&type=template&id=6a529fcc&ts=true"
import script from "./DynamicInputNumber.vue?vue&type=script&lang=ts"
export * from "./DynamicInputNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicInputNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a529fcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a529fcc', __exports__)) {
    api.reload('6a529fcc', __exports__)
  }
  
  module.hot.accept("./DynamicInputNumber.vue?vue&type=template&id=6a529fcc&ts=true", () => {
    api.rerender('6a529fcc', render)
  })

}


export default __exports__